export default Object.freeze({
  USD: 1,
});
